import React from "react";
import Header from "../layouts/Header";
import About from "../layouts/About";
import Promises from "../layouts/Promises";
import Services from "../layouts/Services";
import FactCounter from "../layouts/FactCounter";
import Footer from "../layouts/Footer";
import PortfolioLayout from "../layouts/PortfolioLayout";
import ThemeShowcase from "../layouts/ThemeShowcase";
// import BrandSection from "../components/BrandsSection/BrandSection";
import HomepageBanner1 from "../components/Banners/HomepageBanners/HomepageBanner1";
import TestimonialSlider from "../components/TestimonialSlider/TestimonialSlider";
import useScrollToHash from "../Helpers/useScrollToHash";
import usePageMeta from "../Helpers/usePageMeta";

const Home = () => {
  usePageMeta({
    title: "TZ Creation | Product, UX & Frontend Staff Augmentation",
    description:
      "TZ Creation provides Product, UX, and Frontend Engineering staff augmentation and dedicated teams for healthcare, edtech, and HR tech companies -- see real, shipped work on our Case Studies page.",
    path: "/",
  });

  // Scrolls to the section named in the URL hash (e.g. /#services), else to the top.
  useScrollToHash();

  return (
    <>
      <Header />
      <HomepageBanner1 />
      <About />
      <Promises />
      <Services />
      <FactCounter />
      <PortfolioLayout />
      <ThemeShowcase />
      <TestimonialSlider />
      {/* <BrandSection /> */}
      <Footer />
    </>
  );
};

export default Home;
